// extracted by mini-css-extract-plugin
export default {"StyledReceipt":"initMoneyPool_StyledReceipt__A-224"};